/* Added by Ben on 20-Jan-2025 */
/**
 * Observes the "Add to Cart" button state for product variants.
 * If a product variant is sold out for not live, the button state is updated
 * to display a "Notify Me" option."
 *
 * Functionality:
 * - Monitors product variant availability.
 * - Displays a "Notify Me" div for non-live sold-out variants.
 * - Ensures seamless user interaction for unavailable product options.
 */
document.addEventListener("DOMContentLoaded", function () {
  // Function to handle the button state and toggle "Notify Me"
  function handleButtonChange() {
    const NotifyMeSoldOut = document.getElementById("soldout_notify_me");
    
    // Ensure the "Notify Me" div exists
    if (!NotifyMeSoldOut) {
      console.warn('"Notify Me" div (#soldout_notify_me) not found.');
      return;
    }

    NotifyMeSoldOut.style.display = "none";

    const button = document.querySelector(
      'button[name="add"].product-form__submit.button.button--full-width.button--secondary'
    );

    if (button) {
      const span = button.querySelector("span");
      if (span && span.textContent.trim() === "Sold out" && button.disabled) {
        NotifyMeSoldOut.style.display = "flex";
      }
      // else if (span && span.textContent.trim() === "Unavailable" && button.disabled) {
      //   NotifyMeSoldOut.style.display = "flex";
      // }
    } else {
      console.warn("Add to Cart button not found.");
    }
  }

  // Function to observe button changes using MutationObserver
  function observeButtonChanges() {
    const button = document.querySelector(
      'button[name="add"].product-form__submit.button.button--full-width.button--secondary'
    );

    if (button) {
      const observer = new MutationObserver(() => {
        handleButtonChange();
      });

      observer.observe(button, {
        attributes: true,
        childList: true,
        subtree: true,
      });

      console.log("Observer attached to Add to Cart button.");
    } else {
      console.warn("Button not found. Retrying...");
      setTimeout(observeButtonChanges, 100); // Retry until the button exists
    }
  }

  // Initialize the functionality, ensuring all required elements are loaded
  function initialize() {
    //const NotifyMeSoldOut = document.getElementById("soldout_notify_me");
    const button = document.querySelector(
      'button[name="add"].product-form__submit.button.button--full-width.button--secondary'
    );

    //if (NotifyMeSoldOut && button) {
    if (button) {
      handleButtonChange();
      observeButtonChanges();
    } else {
      console.warn("Required elements not found. Retrying...");
      setTimeout(initialize, 100); // Retry until elements exist
    }
  }

  // Start the initialization process
  initialize();
});
